import React, { useCallback, useRef, useState } from 'react';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import { format, parseISO } from 'date-fns';
import { Button } from 'react-bootstrap';
import { useToast } from '../../../hooks/toast';
import api from '../../../services/api';
import getResponseErrors from '../../../utils/getResponseErrors';
import TextArea from '../../../components/TextArea';

export interface IComentario {
  ComCodigo: number;
  ComOrigem: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13;
  ComOrigemTexto: string;
  ComComentario: string;
  ComData: Date;
  ComDataFormatado: string;
  ComDataAviso: Date;
  ComUsuNome: string;
  ComPlaCodigo: number;
}

export const origemComentario = {
  0: 'COMENTÁRIO',
  1: 'COBRANÇA FINANCEIRA',
  2: 'ALTERAÇÃO TITULAR',
  3: 'ALTERAÇÃO VENCIMENTO',
  4: 'ALTERAÇÃO RESPONSÁVEL',
  5: 'INCLUSÃO DEPENDENTE',
  6: 'EXCLUSÃO DEPENDENTE',
  7: 'RENOVAÇÃO',
  8: 'CANCELAMENTO',
  9: 'NOVO CARTÃO',
  10: 'EXCLUSÃO RESPONSÁVEL',
  11: 'INCLUSÃO CHIP',
  12: 'EXCLUSÃO CHIP',
  13: 'INCLUSÃO BENEFÍCIO',
  14: 'ASSINATURA CONTRATO',
};

type Props = {
  plaCodigo: number;
  origem?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14;
  handleRetorno(comentario: IComentario): void;
};
const ComentarioCadastro: React.FC<Props> = ({
  plaCodigo,
  origem,
  handleRetorno,
}) => {
  const { addToast } = useToast();
  const formRefComentario = useRef<FormHandles>(null);
  const [loading, setLoading] = useState(false);

  const handleSubmitComentario = useCallback(
    async (dados: { comentario: string }) => {
      setLoading(true);
      const { comentario } = dados;
      try {
        if (!comentario || comentario.length === 0) {
          formRefComentario.current?.setFieldError(
            'comentario',
            'Comentário é obrigatório',
          );
          return;
        }

        const response = await api.post<IComentario>(
          `planos/comentarios/${plaCodigo}`,
          {
            comentario: comentario.toUpperCase(),
            ComOrigem: origem,
          },
        );
        // setShowModalComentario(false);

        const comentarioFormatado = {
          ...response.data,
          ComDataFormatado: format(
            parseISO(response.data.ComData.toString()),
            'dd/MM/yyyy',
          ),
          ComDataAvisoFormatado: response.data.ComDataAviso
            ? format(
                parseISO(response.data.ComDataAviso.toString()),
                'dd/MM/yyyy',
              )
            : '',
          ComOrigemTexto: origemComentario[response.data.ComOrigem || 0],
        };
        handleRetorno(comentarioFormatado);
      } catch (error) {
        const mensagemErro = getResponseErrors(error);
        addToast({
          title: 'Não foi possível salvar comentário',
          type: 'error',
          description: mensagemErro,
        });
      } finally {
        setLoading(false);
      }
    },
    [plaCodigo, addToast, handleRetorno, origem],
  );

  return (
    <Form
      ref={formRefComentario}
      className="mt-2 pb-5"
      onSubmit={handleSubmitComentario}
    >
      <TextArea label="Comentário" name="comentario" rows={6} />
      <Button
        type="submit"
        className="mt-2"
        variant="success"
        disabled={loading}
      >
        Salvar
      </Button>
    </Form>
  );
};

export default ComentarioCadastro;
